<p-card
	[header]="((notification$ | async)?.sourceUser$ | async)?.name"
	styleClass="p-card-no-padding"
>
	<spr-user-metadata
		[locale]="locale$ | async"
		[user]="(notification$ | async)?.sourceUser$ | async"
	></spr-user-metadata>
</p-card>
<div
	[translate]="'presentation.app.common.dialog.meetingRequest.date'"
	[translateParams]="{
		day:
			(notification$ | async)?.meeting?.startDate
			| date: 'fullDate':null:(locale$ | async),
		startHour:
			(notification$ | async)?.meeting?.startDate
			| date: 'shortTime':null:(locale$ | async),
		endHour:
			(notification$ | async)?.meeting?.endDate
			| date: 'shortTime':null:(locale$ | async)
	}"
	class="text-xl leading-normal font-medium text-center px-0"
	style="margin-top: 30px; margin-bottom: 30px"
></div>
<div
	class="
		flex
		md:flex-row
		flex-col
		md:space-x-3 md:space-y-0
		space-y-3
		mt-3
		md:items-center md:justify-between
	"
>
	<button
		[label]="
			'presentation.app.common.dialog.meetingRequest.actions.reject' | translate
		"
		(click)="onRejectClick()"
		class="p-button-danger"
		icon="far fa-times-circle"
		pButton
	></button>
	<button
		[label]="
			'presentation.app.common.dialog.meetingRequest.actions.change' | translate
		"
		(click)="onChangeClick()"
		icon="far fa-calendar-alt"
		pButton
	></button>
	<button
		[label]="
			'presentation.app.common.dialog.meetingRequest.actions.accept' | translate
		"
		(click)="onAcceptClick()"
		class="p-button-success"
		icon="far fa-check-circle"
		pButton
	></button>
</div>
